import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

let messages = {
  en: {
    signOut: 'Sign out',
    personalInformation: 'Personal information',
    documentation: 'Documentation',
    security: 'Security',
    membership: 'Membership',
    payments: 'Payments',
    driverLicense: "Driver's license",
    identityCard: 'Identity card',
    upload: 'Upload',
    genres: {
      M: 'Masculine',
      F: 'Femenine',
      Other: 'Other',
    },
    labels: {
      email: 'Email',
      address: 'Address',
      genre: 'Genre',
      referralCode: 'Referral code',
      phone: 'Phone',
      rut: 'RUT/RUN',
      passport: 'Passport',
      birth: 'Birth date',
      driverLicenseIssuanceDate: 'License issuance date',
      driverLicenseExpirationDate: 'License expiration date',
      identityCardIssuanceDate: 'Document issuance date',
      identityDocumentExpirationDate: 'Document expiration date',
      status: 'Status',
      restrictedCars: 'Restricted cars',
      blockMembership: 'Membership change',
      bypassReserveLock: 'Reservation lock bypass',
      forceVerification: 'Force verification',
      newPassword: 'New password',
      newPasswordConfirm: 'Confirm new password',
      newPin: 'New password',
      newPinConfirm: 'Confirm new pin',
      membership: 'Membership',
      renewalDate: 'Renewal date',
      nextMembership: 'Next membership',
      chargeType: 'Charge type',
      method: 'Payment method',
      subscriptionDate: 'Fecha de suscripción',
      resident: 'Resident',
      foreigner: 'Foreigner',
      sendMailCheck: 'Send status change email',
    },
    validationMessages: {
      required: 'This field is required',
      password: 'This field must contain at least 6 characters',
      pin: 'This field must contain 4 characters',
      expiration: 'The expiration date cannot be earlier than the issue date',
      issue: 'The issue date cannot be a future date',
      email: 'This is not a valid email',
      rut: 'This field is not valid',
      confirmPassword: 'Passwords do not match',
      confirmPin: 'Pins do not match',
      integer: 'This field must be an integer',
      phone: 'This is not a valid phone number',
    },
    buttons: {
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      close: 'Close',
      sendByEmail: 'Send by email',
      enterManually: 'Manually',
      changePassword: 'Change password',
      changePin: 'Change pin',
      agree: 'Agree',
    },
    toast: {
      editSuccess: 'The information was updated successfully',
      checkFormRequirements: 'Please check the form carefully for errors',
      networkError: 'Network or server error, please try again',
      unexpectedError: 'An unexpected error has occurred, please try again',
      sessionError: 'Session timed out, please login again',
      serverError: 'An error has occurred on the server, please try again',
      imgError:
        'The image could not be updated but the rest of the form will update anyway',
      error404: 'The resource was not found',
      mailSuccess: 'The email was sent successfully',
      pinSuccess: 'The PIN was sent successfully',
      loginWrongCredentials:
        'The credentials are wrong, please try again. If the problem persists, please contact the call center.',
      redirectionTimeout: 'Redirect timed out',
      revokedSession: 'The session was revoked',
    },
    statuses: {
      DOCUMENT: 'Document',
      PAYMENT: 'Payment',
      REVIEW: 'Review',
      DEACTIVE: 'Deactive',
      ACTIVE: 'Active',
      REJECTED: 'Rejected',
      SUSPENDED: 'Suspended',
      BLACKLIST: 'Blacklist',
      PHONE_VERIFY: 'Phone Verify',
      TOC_ID: 'TOC ID',
      TOC_SELFIE: 'TOC Selfie',
      MANUAL_DOCUMENT: 'Manuel Document',
      DRIVE_DOCUMENT: 'Drive Document',
      GENERAL_INFORMATION: 'General Information',
      MEMBERSHIP: 'Membership',
      NONE: 'Creating',
      PHONE_NUMBER: 'Phone Number',
      MANUAL_DOCUMENT_SELFIE: 'Manual Document Selfie',
    },
    licenseTypes: {
      car: 'Class B (Car)',
      motto: 'Class C (Motto)',
    },
    booleans: {
      active: 'Active',
      deactive: 'Deactive',
      loqued: 'Loqued',
      unloqued: 'Unloqued',
    },
    confirmations: {
      generatePassword:
        'Are you sure to generate a new password for this user and send it by email?',
      generatePin:
        'Are you sure to generate a new pin for this user and send it by email?',
      areYouSure: 'Are you sure?',
      sendMail: 'Do you want to send an email to the user?',
    },
    chargeTypes: {
      PREPAID: 'Prepaid',
      POSTPAID: 'Postpaid',
    },
    tableTitles: {
      payments: 'Payment history',
    },
    tableHeaders: {
      orderId: 'Order ID',
      creationDate: 'Creation date',
      totalAmount: 'Total amount',
      status: 'Status',
    },
  },
  es: {
    signOut: 'Cerrar sesión',
    personalInformation: 'Información personal',
    documentation: 'Documentación',
    security: 'Seguridad',
    membership: 'Membresía',
    payments: 'Pagos',
    driverLicense: 'Licencia de conducir',
    identityCard: 'Documento de identidad',
    upload: 'Subir',
    genres: {
      M: 'Masculino',
      F: 'Femenino',
      Other: 'Otro',
    },
    labels: {
      email: 'Correo',
      address: 'Dirección',
      genre: 'Género',
      referralCode: 'Cod. referido',
      phone: 'Teléfono',
      rut: 'RUT/RUN',
      passport: 'Pasaporte',
      birth: 'F. nacimiento',
      driverLicenseIssuanceDate: 'Emisión licencia',
      driverLicenseExpirationDate: 'Expiración licencia',
      identityCardIssuanceDate: 'Emisión documento',
      identityDocumentExpirationDate: 'Expiración documento',
      status: 'Estado',
      restrictedCars: 'Vehículos restringidos',
      blockMembership: 'Cambio de membresía',
      bypassReserveLock: 'Bypass bloqueo reserva',
      forceVerification: 'Forzar verificación',
      newPassword: 'Nueva contraseña',
      newPasswordConfirm: 'Confirmar nueva contraseña',
      newPin: 'Nuevo pin',
      newPinConfirm: 'Confirmar nuevo pin',
      membership: 'Membresía',
      renewalDate: 'Fecha de renovación',
      nextMembership: 'Próxima membresía',
      chargeType: 'Tipo de cargo',
      method: 'Medio de pago',
      subscriptionDate: 'Fecha de suscripción',
      resident: 'Nacional',
      foreigner: 'Extranjero',
      sendMailCheck: 'Enviar mail de cambio de estado',
    },
    validationMessages: {
      required: 'Este campo es requerido',
      password: 'Este campo debe tener al menos 6 caracteres',
      pin: 'Este campo debe tener 4 caracteres',
      expiration:
        'La fecha de expiración no puede ser anterior a la fecha de emisión',
      issue: 'La fecha de emisión no puede estar en el futuro',
      email: 'Este no es un email válido',
      rut: 'El RUT no es válido',
      confirmPassword: 'Las contraseñas no coinciden',
      confirmPin: 'Los pines no coinciden',
      integer: 'Este campo debe ser un número entero',
      phone: 'Este campo debe ser un número telefónico válido',
    },
    buttons: {
      save: 'Guardar',
      cancel: 'Cancelar',
      edit: 'Editar',
      close: 'Cerrar',
      sendByEmail: 'Enviar por email',
      enterManually: 'Manualmente',
      changePassword: 'Cambiar contraseña',
      changePin: 'Cambiar pin',
      agree: 'Aceptar',
      send: 'Enviar',
    },
    toast: {
      editSuccess: 'La información ha sido actualizada correctamente',
      checkFormRequirements: 'Favor de verificar los requisitos del formulario',
      networkError: 'Error de red o de servidor, favor de intentar nuevamente',
      unexpectedError:
        'Se ha producido un error inesperado, favor de intentar nuevamente',
      sessionError:
        'Se agotó el tiempo de la sesión, favor de iniciar sesión nuevamente',
      serverError:
        'Ha ocurrido un error en el servidor, favor de intentar nuevamente',
      imgError:
        'La imagen no pudo ser actualizada pero el resto del formulario se actualizará de todos modos',
      error404: 'El recurso no pudo ser encontrado',
      mailSuccess: 'Mail enviado correctamente',
      pinSuccess: 'PIN enviado correctamente',
      loginWrongCredentials:
        'Las credenciales ingresadas son incorrectas. Si el problema persiste, favor de contactar a call center.',
      redirectionTimeout:
        'Se ha superado el tiempo de espera para la redirección',
      revokedSession: 'La sesión fue revocada',
    },
    statuses: {
      DOCUMENT: 'Documento',
      PAYMENT: 'Pago',
      REVIEW: 'Revisión',
      DEACTIVE: 'Inactivo',
      ACTIVE: 'Activo',
      REJECTED: 'Rechazado',
      SUSPENDED: 'Suspendido',
      BLACKLIST: 'Lista Negra',
      PHONE_VERIFY: 'Verificación de Teléfono',
      TOC_ID: 'Documento de Identidad (TOC)',
      TOC_SELFIE: 'Selfie (TOC)',
      MANUAL_DOCUMENT: 'Documento de Identidad (Manual)',
      DRIVE_DOCUMENT: 'Licencia de Conducir',
      GENERAL_INFORMATION: 'Información General',
      MEMBERSHIP: 'Membresía',
      NONE: 'Creando',
      PHONE_NUMBER: 'Número de Teléfono',
      MANUAL_DOCUMENT_SELFIE: 'Selfie (Manual)',
    },
    licenseTypes: {
      car: 'Clase B (Auto)',
      motto: 'Clase C (Moto)',
    },
    booleans: {
      active: 'Activo',
      deactive: 'Inactivo',
      loqued: 'Bloqueado',
      unloqued: 'Desbloqueado',
    },
    confirmations: {
      generatePassword:
        '¿Estás seguro/a de generar una nueva contraseña y enviarla vía mail?',
      generatePin:
        '¿Estás seguro/a de generar un nuevo PIN y enviarlo vía mail?',
      areYouSure: '¿Estás seguro/a?',
      sendMail: '¿Desea enviar un mail al usuario?',
    },
    chargeTypes: {
      PREPAID: 'Prepago',
      POSTPAID: 'Postpago',
    },
    tableTitles: {
      payments: 'Historial de pagos',
    },
    tableHeaders: {
      orderId: 'N° Orden',
      creationDate: 'Fecha de creación',
      totalAmount: 'Monto total',
      status: 'Estado',
    },
  },
  pt: {
    signOut: 'Sair',
    personalInformation: 'Informação pessoal',
    documentation: 'Documentação',
    security: 'Segurança',
    membership: 'Adesão',
    payments: 'Pagamentos',
    driverLicense: 'Carteira de motorista',
    identityCard: 'Identidade',
    upload: 'Ascender',
    genres: {
      M: 'Masculino',
      F: 'Feminino',
      Other: 'Outros',
    },
    labels: {
      email: 'email',
      address: 'Endereço',
      genre: 'Gênero',
      referralCode: 'COD. Referido',
      phone: 'Telefone',
      rut: 'CPF',
      passport: 'Passaporte',
      birth: 'Data de Nascimento',
      driverLicenseIssuanceDate: 'Emissão da CNH',
      driverLicenseExpirationDate: ' Expiração da CNH',
      identityCardIssuanceDate: 'Emissão do Documento',
      identityDocumentExpirationDate: 'Expiração do documento',
      status: 'Status',
      restrictedCars: 'Veículos restritos',
      blockMembership: 'Mudança na adesão',
      bypassReserveLock: 'Bypass Block Book.',
      forceVerification: 'Verificação de força',
      newPassword: 'Nova senha',
      newPasswordConfirm: 'Confirme a nova senha',
      newPin: 'Novo pin',
      newPinConfirm: 'Confirmar novo pin',
      membership: 'Adesão',
      renewalDate: 'Data de renovação',
      nextMembership: 'Próxima Adesão',
      chargeType: 'Tipo de carga',
      method: 'Meio de pagamento',
      subscriptionDate: 'Data de inscrição',
      resident: 'Nacional',
      foreigner: 'Estrangeiro',
      sendMailCheck: 'Enviar mensagens de mudança de estado',
    },
    validationMessages: {
      required: 'Este campo é obrigatório',
      password: 'Este campo deve ter pelo menos 6 caracteres',
      pin: 'Este campo deve ter 4 caracteres',
      expiration:
        'A data de vencimento não pode ser anterior à data de emissão',

      issue: 'A data de emissão não pode ser no futuro',
      email: 'Este não é um email válido',
      rut: 'Este campo não é válido',
      confirmPassword: 'As senhas não  coincidem',
      confirmPin: 'Os pins não coincidem',
      integer: 'Este campo deve ser um n° inteiro',
      phone: 'Este campo deve ser um número de telefone válido',
    },
    buttons: {
      save: 'Salvar',
      cancel: 'Cancelar',
      edit: 'Editar',
      close: 'Fechar',
      sendByEmail: 'Enviar por email',
      enterManually: 'Manualmente',
      changePassword: 'Mudar senha',
      changePin: 'Alterar Pin',
      agree: 'Aceitar',
    },
    toast: {
      editSuccess: 'A informação foi atualizada corretamente',
      checkFormRequirements: 'Por favor, verifique os requisitos da forma',
      networkError: 'Erro de rede ou servidor, tente novamente',
      unexpectedError: 'Ocorreu um erro inesperado, tente novamente',

      sessionError: 'Sessão expirou, faça login novamente',

      serverError: 'Ocorreu um erro no servidor, tente novamente',

      imgError:
        'A imagem não pôde ser atualizada, mas o restante do formulário será atualizado de qualquer maneira',

      error404: 'O recurso não pôde ser encontrado',
      mailSuccess: 'email enviado corretamente',
      pinSuccess: 'PIN enviado corretamente',
      loginWrongCredentials:
        'As credenciais inseridas estão incorretas. Se o problema persistir, entre em contato com a central de atendimento.',

      redirectionTimeout: 'O redirecionamento expirou',

      revokedSession: 'A sessão foi revogada',
    },
    statuses: {
      DOCUMENT: 'Documento',
      PAYMENT: 'Pagamento',
      REVIEW: 'Revisão',
      DEACTIVE: 'Inativo',
      ACTIVE: 'Ativo',
      REJECTED: 'Rejeitado',
      SUSPENDED: 'Interrompido',
      BLACKLIST: 'Lista negra',
      PHONE_VERIFY: 'Verificação por telefone',
      TOC_ID: 'Documento de identidade (TOC)',
      TOC_SELFIE: 'Selfie (TOC)',
      MANUAL_DOCUMENT: 'Documento de identidade (manual)',
      DRIVE_DOCUMENT: 'Carteira de motorista',
      GENERAL_INFORMATION: 'Informações gerais',
      MEMBERSHIP: 'Adesão',
      NONE: 'Criando',
      PHONE_NUMBER: 'Número de telefone',
      MANUAL_DOCUMENT_SELFIE: 'Selfie (manual)',
    },
    licenseTypes: {
      car: 'Classe B (Auto)',
      motto: 'Classe A (moto)',
    },
    booleans: {
      active: 'Ativo',
      deactive: 'Inativo',
      loqued: 'Bloqueado',
      unloqued: 'Desbloqueado',
    },
    confirmations: {
      generatePassword:
        'Tem certeza de gerar uma nova senha e enviá-la por e-mail?',

      generatePin: 'Tem certeza de gerar um novo PIN e enviá-lo por e-mail?',

      areYouSure: 'Tem certeza?',
      sendMail: 'Você quer enviar um email para o usuário?',
    },
    chargeTypes: {
      PREPAID: 'Pré-pago',
      POSTPAID: 'Pós-pago',
    },
    tableTitles: {
      payments: 'Histórico de pagamento',
    },
    tableHeaders: {
      orderId: 'n° Ordem',
      creationDate: 'Data de criação',
      totalAmount: 'Valor total',
      status: 'status',
    },
  },
};

messages = {
  es: {
    ...messages.es,
    m1: 'Iniciar sesión',
    m2: 'Registro',
    m3: 'Contraseña',
    m4: '¿Olvidaste tu contraseña?',
    m5: 'o',
    m6: 'Continua con Facebook',
    m7: 'Continua con Google',
    m8: '¿No tienes una cuenta?',
    m9: 'Crea tu contraseña',
    m10: 'Ocultar',
    m11: 'Mostrar',
    m12: 'Repite tu contraseña',
    m13: 'He leído y acepto los',
    m14: 'términos y condiciones',
    m15: 'Continuar al paso ',
    m16: 'Ingresa tu número teléfonico para validar tu dispositivo',
    m17: 'El número telefónico no es válido, verifique nuevamente',
    m18: 'Continuar con email',
    m19: 'Únete a los que se mueven inteligente',
    m20: '¿Ya tienes una cuenta?',
    m21: 'Recupera tu contraseña',
    m22:
      'Ingresa tu correo electrónico y te enviaremos un token de seguridad para restablecer tu contraseña',
    m23: 'Enviar correo electrónico de recuperación',
    m24: 'Token Inválido',
    m25: 'El token no es válido, inicie el proceso nuevamente.',
    m26: 'Reestablece tu contraseña',
    m27:
      'Hemos enviado un link a tu correo para continuar con el proceso de nueva contraseña',
    m28: '¡Ya queda poco!. Escribe tu nueva contraseña',
    m29: 'Nueva contraseña',
    m30: 'Reingresar nueva contraseña',
    m31: 'Restablecer mi contraseña',
    m32: 'Calle / Avenida / Número / Depto / Block',
    m33: 'Serás redirigido a la página de registro en los siguientes segundos',
    m34: 'Cargando',
    m35: 'Continuar con el registro',
    m36:
      'Ingresa el código de 4 digitos que acabamos de enviar a tu dispositivo',
    m37: '¿No recibiste el codigo?',
    m38: 'Solicitar un nuevo código',
    m39: ' segundos para solicitar un nuevo código',
    m40: 'Atrás',
    m41: 'Validar código',
    m42:
      'Este proceso nos ayuda a comprobar tu identidad y garantizar la seguridad de tus documentos en nuestra plataforma.',
    m43: 'Por favor, selecciona el ',
    m44: 'tipo de tu documento vigente',
    m45: ' a registrar para dar comienzo a tu proceso de verificación.',
    m46: '¿En qué consiste la verificación?',
    m47: '¿Cómo protegen mis datos?',
    m48: 'Comenzar mi verificación',
    m49: '¿Cómo protegen mis datos?',
    m50:
      'En {awto} estamos comprometidos con la seguridad y privacidad de los datos de nuestros usuarios. Es por esto que te comentamos cómo cuidamos tu información:',
    m51:
      'Karsharing se obliga a guardar reserva y confidencialidad de los datos proporcionados por el Afiliado.',
    m52:
      'Toda la información del servicio {awto} es completamente anónimo y no se compromete la información personal de los usuarios.',
    m53:
      'Toda información sensible relacionado a tarjetas bancarias (crédito / débito) no son guardadas en la aplicación.',
    m54:
      'Sistema de seguridad doble (Clave - PIN) para evitar suplantación de identidad. Se pide foto de la persona más documentos para validar identidad de los usuarios.',
    m55: 'Nota',
    m56:
      'Según lo dispuesto en la Ley Nº19.628 de la legislación chilena sobre protección de vida privada y protección de datos de carácter personal, el Afiliado expresa a Karsharing para almacenar, conservar, custodiar y transmitir a registros o bancos de datos personales, información de carácter financiero, económico bancario o comercial, exclusivamente referida al cumplimiento de obligaciones derivadas del presente contrato, sus modificaciones y/o instrumentos anexos o accesorios, con el objeto de que sea publicada por dichas entidades.',
    m57: '¿En qué consiste la verificación de documento e identidad?',
    m58:
      'Este proceso nos ayuda a tener certeza de saber quien eres. La verificación de identidad se realizará a través del sistema TOC el cual te contamos como opera y en qué te beneficia',
    m59: '¿Qué es TOC?',
    m60:
      'TOC Biometrics es un sistema que permite verificar la identidad de una persona a través de su documentación como también por reconocimiento facial, lo cual hace posible enrolar a los usuarios de forma rápida y eficiente.',
    m61:
      'Este sistema garantiza la seguridad, privacidad y total trazabilidad de cada una de las operaciones.',
    m62:
      'TOC no utiliza ni almacena datos sensibles para verificar la identidad de los usuarios;',
    m63:
      'ya que no consulta a una base de datos, eliminando así la vulnerabilidad ante hackeos y el robo de información privada.',
    m64:
      '¿Qué debo hacer si soy ciudadano chileno o extranjero residente en Chile?',
    m65: '1. Selecciona cédula Nueva o antigua a verificar.',
    m66: 'Si eres residente, debes realizar la misma acción.',
    m67: 'Soy turista o aún no tengo mis documentos de residencia',
    m68: '1. Presiona la opción Todos los documentos.',
    m69:
      '2. Escoge del listado la opción de “Pasaporte All” para continuar con tu registro.',
    m70: 'Por alguna razón mi verificación en TOC falló. ¿Qué debo hacer?',
    m71:
      'En este caso, el proceso de verificación se realizará de forma manual a través de nuestro sistema interno. Te solicitaremos que añadas fotografías de tus documentos y además una selfie con ellos en mano. Este proceso requiere de mayor tiempo para completar.',
    m72:
      'Este proceso nos ayuda a tener certeza de saber que tu documentación está vigente para usar {awto}.',
    m73: 'Subir foto Frontal',
    m74: 'Subir foto Reversa',
    m75: 'Agrega tu cédula de identidad',
    m76:
      'Este proceso nos ayuda a tener certeza de saber que tu documentación está vigente para usar {awto}.',
    m77:
      'Este proceso nos ayuda a saber si tu licencia cuenta con una vigencia de dos años',
    m78: 'Verificación de identidad facial',
  },
  en: {
    ...messages.en,
    m1: 'Login',
    m2: 'Register',
    m3: 'Password',
    m4: 'Forgot password?',
    m5: 'or',
    m6: 'Login with Facebook',
    m7: 'Login with Google',
    m8: "Don't have an account?",
    m9: 'Create your password',
    m10: 'Hide',
    m11: 'Show',
    m12: 'Repeat your password',
    m13: "I've read and agreed our",
    m14: 'terms and conditions',
    m15: 'Continue to step ',
    m16: 'Enter your number to validate your device',
    m17: 'Phone number invalid, try again',
    m18: 'Continue with email',
    m19: 'Join the smart move',
    m20: 'Already have an account?',
    m21: 'Recover your password',
    m22:
      'Enter your email and we will send you a link to recover your password',
    m23: 'Send recovery email',
    m24: 'Invalid token',
    m25: 'Invalid token, try again',
    m26: 'Reset your password',
    m27:
      'We have sent a link to your email to continue with the process of new password',
    m28: 'You have only one chance!. Write your new password',
    m29: 'New password',
    m30: 'Repeat new password',
    m31: 'Reset my password',
    m32: 'Street / Avenue / Number / Dept / Block',
    m33: 'You will be redirected to the registration page in the next seconds',
    m34: 'Loading',
    m35: 'Continue with registration',
    m36: 'Enter the 4 digits code that we sent to your device',
    m37: "Didn't receive the code?",
    m38: 'Request a new code',
    m39: ' seconds to request a new code',
    m40: 'Back',
    m41: 'Validate code',
    m42:
      'This process helps us to verify your identity and guarantee the security of your documents in our platform.',
    m43: 'Please, select the ',
    m44: 'type of your current document',
    m45: ' to start your verification process.',
    m46: 'What is the verification?',
    m47: 'How are my data protected?',
    m48: 'Start my verification',
    m49: 'How are my data protected?',
    m50:
      'In {awto} we are committed to the security and privacy of our users data. It is therefore that we advise you how we handle your information:',
    m51:
      'Karsharing is obligated to keep reservation and confidentiality of the data provided by the Affiliate.',
    m52:
      'All information of the service {awto} is completely anonymous and we are not responsible for the personal information of the users.',
    m53:
      'All sensitive information related to credit / debit cards (credit / debit) are not stored in the application.',
    m54:
      'Double security system (Key - PIN) to avoid impersonation of identity. It is required a photo of the person with documents to validate identity of the users.',
    m55: 'Note',
    m56:
      'According to the Law Nº19.628 of the Chilean law on the protection of life private and the protection of personal data, the Affiliate expresses to Karsharing for storage, custody and transmission of records or banks of personal data, information of financial or economic nature, exclusively referred to the fulfillment of obligations derived from this contract, its modifications and/or annexes, with the objective of that it is published by such entities.',
    m57: 'What is the verification of document and identity?',
    m58:
      'This process helps us to know who you are. The verification of identity will be performed through the system TOC which we will tell you as operates and in what benefits.',
    m59: 'What is TOC?',
    m60:
      'TOC Biometrics is a system that allows to verify the identity of a person through their documentation as well as by facial recognition, which makes possible enrolling users in a fast and efficient way.',
    m61:
      'This system guarantees the security, privacy and total traceability of each operation.',
    m62:
      'TOC does not use nor stores sensitive data to verify the identity of the users;',
    m63:
      'because it does not consult a database, eliminating as such the vulnerability against hacks and the theft of private information.',
    m64:
      'What should I do if I am a Chilean citizen or foreign resident in Chile?',
    m65: '1. Select the type of your current document.',
    m66: 'If you are a resident, you must do the same action.',
    m67: 'I am a tourist or I still do not have my documents of residence',
    m68: '1. Click on the option All documents.',
    m69:
      '2. Choose from the list the option of "Passport All" to continue with your registration.',
    m70: 'For some reason my verification in TOC failed. What should I do?',
    m71:
      'In this case, the verification process will be performed manually through our internal system. We will request you to add photos of your documents and also a selfie with them in hand. This process requires more time to complete.',
    m72:
      'This process helps us to have certainty that your documentation is valid to use {awto}.',
    m73: 'Upload photo Frontal',
    m74: 'Upload photo Reversa',
    m75: 'Add your ID card',
    m76:
      'This process helps us to have certainty that your documentation is valid to use {awto}.',
    m77:
      'This process helps us to know if your license has a validity of two years',
    m78: 'Facial identification verification',
  },
  pt: {
    ...messages.pt,
    m1: 'Iniciar sessão',
    m2: 'Registro',
    m3: 'Senha',
    m4: 'Esqueceu sua senha?',
    m5: 'ou',
    m6: 'Continua com Facebook',
    m7: 'Continua com Google',
    m8: 'Não tem uma conta?',
    m9: 'Crie sua senha',
    m10: 'Ocultar',
    m11: 'Mostrar',
    m12: 'Repita sua senha',
    m13: 'Eu li e aceito os',
    m14: 'termos e condições',
    m15: 'Continuar ao passo ',
    m16: 'Insira seu número de telefone para validar seu dispositivo',
    m17: 'O número de telefone é inválido, verifique novamente',
    m18: 'Continuar com email',
    m19: 'Junte-se aos que se movem inteligentemente',
    m20: 'Já tem uma conta?',
    m21: 'Recupere sua senha',
    m22:
      'Insira seu e-mail e enviaremos um token de segurança para recuperar sua senha',
    m23: 'Enviar e-mail de recuperação',
    m24: 'Token Inválido',
    m25: 'O token não é válido, inicie o processo novamente.',
    m26: 'Redefina sua senha',
    m27:
      'Enviamos um link para seu e-mail para continuar com o processo de nova senha',
    m28: 'Você tem apenas uma chance!. Escreva sua nova senha',
    m29: 'Nova senha',
    m30: 'Repita a nova senha',
    m31: 'Redefina minha senha',
    m32: 'Rua / Avenida / Número / Dept / Bloco',
    m33: 'Você será redirecionado para a página de registro em alguns segundos',
    m34: 'Carregando',
    m35: 'Continuar com o registro',
    m36: 'Insira o código de 4 dígitos que enviamos ao seu dispositivo',
    m37: 'Não recebeu o código?',
    m38: 'Solicitar um novo código',
    m39: ' segundos para solicitar um novo código',
    m40: 'Voltar',
    m41: 'Validar código',
    m42:
      'Este processo nos ajuda a verificar sua identidade e garantir a segurança de seus documentos na nossa plataforma.',
    m43: 'Por favor, selecione o ',
    m44: 'tipo de seu documento atual',
    m45: ' para iniciar o processo de verificação.',
    m46: 'O que é a verificação?',
    m47: 'Como protegemos seus dados?',
    m48: 'Começar a minha verificação',
    m49: 'Como protegemos seus dados?',
    m50:
      'Em {awto} estamos comprometidos com a segurança e privacidade dos nossos usuários. Por isso, nós lhe recomendamos como lidamos com seus dados:',
    m51:
      'Karsharing é obrigado a manter reserva e confidencialidade dos dados fornecidos pelo Afiliado.',
    m52:
      'Todos os dados do serviço {awto} são completamente anônimos e nós não somos responsáveis por dados pessoais de usuários.',
    m53:
      'Todos os dados sensíveis relacionados a cartões de crédito / débito (crédito / débito) não são armazenados na aplicação.',
    m54:
      'Segurança dupla (Chave - PIN) para evitar falsificação de identidade. É necessário uma foto da pessoa com documentos para validar a identidade do usuário.',
    m55: 'Nota',
    m56:
      'De acordo com a Lei Nº19.628 do Chile sobre a proteção da vida privada e da proteção dos dados pessoais, o Afiliado expõe-se a Karsharing para armazenamento, custódia e transmissão de registros ou bancos de dados pessoais, informações financeiras ou econômicas, exclusivamente referidas ao cumprimento de obrigações derivadas deste contrato, suas modificações e/ou anexos, com o objetivo de que elas sejam publicadas por tal entidades.',
    m57: 'O que é a verificação de documento e identidade?',
    m58:
      'A verificação de documento e identidade é um processo de verificação de identidade e documento de identidade, que consiste em verificar se o documento de identidade e o documento de identidade do usuário são iguais.',
    m59: 'O que é TOC?',
    m60:
      'TOC é um processo de verificação de identidade e documento de identidade, que consiste em verificar se o documento de identidade e o documento de identidade do usuário são iguais.',
    m61:
      'Este sistema garante a segurança, privacidade e total rastreabilidade de cada operação.',
    m62:
      'TOC não usa nem armazena dados sensíveis para verificar a identidade dos usuários;',
    m63:
      'porque não consulta uma base de dados, eliminando assim a vulnerabilidade contra hacks e roubo de informação privada',
    m64:
      'O que devo fazer se for um cidadão chileno ou residente estrangeiro no Chile?',
    m65: '1. Selecione o tipo do seu documento atual.',
    m66: 'Se você é um residente, você deve fazer a mesma ação',
    m67: 'Sou turista ou ainda não tenho os meus documentos de residência',
    m68: '1. Clique na opção Todos os documentos',
    m69:
      '2. Escolha na lista a opção "Passport All" para continuar com seu registro',
    m70: 'Por algum motivo minha verificação no TOC falhou. O que devo fazer?',
    m71:
      'Neste caso, o processo de verificação será realizado manualmente através do nosso sistema interno. Solicitaremos que você adicione fotos de seus documentos e também uma selfie com eles em mãos. Este processo requer mais tempo para ser concluído',
    m72:
      'Esse processo nos ajuda a ter certeza de que sua documentação é válida para usar {awto}.',
    m73: 'Carregar foto frontal',
    m74: 'Carregar foto de verso',
    m75: 'Adicione sua carteira de identidade',
    m76:
      'Este processo nos ajuda a ter certeza de que sua documentação está atualizada para uso {awto}',
    m77:
      'Este processo nos ajuda a saber se sua licença é válida por dois anos',
    m78: 'Verificação de identidade facial',
  },
  br: {
    ...messages.pt,
    m1: 'Iniciar sessão',
    m2: 'Registro',
    m3: 'Senha',
    m4: 'Esqueceu sua senha?',
    m5: 'ou',
    m6: 'Continua com Facebook',
    m7: 'Continua com Google',
    m8: 'Não tem uma conta?',
    m9: 'Crie sua senha',
    m10: 'Ocultar',
    m11: 'Mostrar',
    m12: 'Repita sua senha',
    m13: 'Eu li e aceito os',
    m14: 'termos e condições',
    m15: 'Continuar ao passo ',
    m16: 'Insira seu número de telefone para validar seu dispositivo',
    m17: 'O número de telefone é inválido, verifique novamente',
    m18: 'Continuar com email',
    m19: 'Junte-se aos que se movem inteligentemente',
    m20: 'Já tem uma conta?',
    m21: 'Recupere sua senha',
    m22:
      'Insira seu e-mail e enviaremos um token de segurança para recuperar sua senha',
    m23: 'Enviar e-mail de recuperação',
    m24: 'Token Inválido',
    m25: 'O token não é válido, inicie o processo novamente.',
    m26: 'Redefina sua senha',
    m27:
      'Enviamos um link para seu e-mail para continuar com o processo de nova senha',
    m28: 'Você tem apenas uma chance!. Escreva sua nova senha',
    m29: 'Nova senha',
    m30: 'Repita a nova senha',
    m31: 'Redefina minha senha',
    m32: 'Rua / Avenida / Número / Dept / Bloco',
    m33: 'Você será redirecionado para a página de registro em alguns segundos',
    m34: 'Carregando',
    m35: 'Continuar com o registro',
    m36: 'Insira o código de 4 dígitos que enviamos ao seu dispositivo',
    m37: 'Não recebeu o código?',
    m38: 'Solicitar um novo código',
    m39: ' segundos para solicitar um novo código',
    m40: 'Voltar',
    m41: 'Validar código',
    m42:
      'Este processo nos ajuda a verificar sua identidade e garantir a segurança de seus documentos na nossa plataforma.',
    m43: 'Por favor, selecione o ',
    m44: 'tipo de seu documento atual',
    m45: ' para iniciar o processo de verificação.',
    m46: 'O que é a verificação?',
    m47: 'Como protegemos seus dados?',
    m48: 'Começar a minha verificação',
    m49: 'Como protegemos seus dados?',
    m50:
      'Em {awto} estamos comprometidos com a segurança e privacidade dos nossos usuários. Por isso, nós lhe recomendamos como lidamos com seus dados:',
    m51:
      'Karsharing é obrigado a manter reserva e confidencialidade dos dados fornecidos pelo Afiliado.',
    m52:
      'Todos os dados do serviço {awto} são completamente anônimos e nós não somos responsáveis por dados pessoais de usuários.',
    m53:
      'Todos os dados sensíveis relacionados a cartões de crédito / débito (crédito / débito) não são armazenados na aplicação.',
    m54:
      'Segurança dupla (Chave - PIN) para evitar falsificação de identidade. É necessário uma foto da pessoa com documentos para validar a identidade do usuário.',
    m55: 'Nota',
    m56:
      'De acordo com a Lei Nº19.628 do Chile sobre a proteção da vida privada e da proteção dos dados pessoais, o Afiliado expõe-se a Karsharing para armazenamento, custódia e transmissão de registros ou bancos de dados pessoais, informações financeiras ou econômicas, exclusivamente referidas ao cumprimento de obrigações derivadas deste contrato, suas modificações e/ou anexos, com o objetivo de que elas sejam publicadas por tal entidades.',
    m57: 'O que é a verificação de documento e identidade?',
    m58:
      'A verificação de documento e identidade é um processo de verificação de identidade e documento de identidade, que consiste em verificar se o documento de identidade e o documento de identidade do usuário são iguais.',
    m59: 'O que é TOC?',
    m60:
      'TOC é um processo de verificação de identidade e documento de identidade, que consiste em verificar se o documento de identidade e o documento de identidade do usuário são iguais.',
    m61:
      'Este sistema garante a segurança, privacidade e total rastreabilidade de cada operação.',
    m62:
      'TOC não usa nem armazena dados sensíveis para verificar a identidade dos usuários;',
    m63:
      'porque não consulta uma base de dados, eliminando assim a vulnerabilidade contra hacks e roubo de informação privada',
    m64:
      'O que devo fazer se for um cidadão chileno ou residente estrangeiro no Chile?',
    m65: '1. Selecione o tipo do seu documento atual.',
    m66: 'Se você é um residente, você deve fazer a mesma ação',
    m67: 'Sou turista ou ainda não tenho os meus documentos de residência',
    m68: '1. Clique na opção Todos os documentos',
    m69:
      '2. Escolha na lista a opção "Passport All" para continuar com seu registro',
    m70: 'Por algum motivo minha verificação no TOC falhou. O que devo fazer?',
    m71:
      'Neste caso, o processo de verificação será realizado manualmente através do nosso sistema interno. Solicitaremos que você adicione fotos de seus documentos e também uma selfie com eles em mãos. Este processo requer mais tempo para ser concluído',
    m72:
      'Esse processo nos ajuda a ter certeza de que sua documentação é válida para usar {awto}.',
    m73: 'Carregar foto frontal',
    m74: 'Carregar foto de verso',
    m75: 'Adicione sua carteira de identidade',
    m76:
      'Este processo nos ajuda a ter certeza de que sua documentação está atualizada para uso {awto}',
    m77:
      'Este processo nos ajuda a saber se sua licença é válida por dois anos',
    m78: 'Verificação de identidade facial',
  },
};

messages = {
  es: {
    ...messages.es,
    m79:
      'Cómo indica la imagen, sitúa tu dispositivo a la altura de tu rostro.',
    m80: 'Evita elementos extra como lentes o gorros',
    m81: 'Verificación facial',
    m82: 'Verificación de identidad facial',
    m83: 'Nombres',
    m84: 'Apellidos',
    m85: 'Revisa tus datos',
    m86: 'RUT / DNI / Pasaporte',
    m87: 'Fecha de nacimiento',
    m88: 'CÉDULA DE IDENTIDAD',
    m89: 'Fecha de emisión',
    m90: 'Fecha de expiración',
    m91: 'LICENCIA DE CONDUCIR',
    m92: 'Paso {step} de {total}',
    m93: 'Escoge tu membresía',
    m94: 'Frecuente',
    m95: 'mensual',
    m96: 'Precio normal',
    m97: 'Accede a toda la flota {awto} con precios exclusivos',
    m98: 'Categoría Premium e Híbrido para que disfrutes de la ciudad',
    m99: 'Cero',
    m100: 'Accede a la flota con precios ajustados a lo que usas',
    m101:
      'Únete a {awto} sin compromisos de pago mensual y viaja cuando lo necesites',
    m102: 'Elige tu método de pago',
    m103: 'Selecciona el método de pago de tu preferencia',
    m104: 'Medio de pago',
    m105: '¿Cómo es el proceso de pago?',
    m106: 'Casi lo olvido...¡Tengo un código!',
    m107:
      'Ingresa un código promocional o referido para añadir minutos gratis a tu viaje',
    m108: 'Ingresa el código',
    m109: 'Validar',
    m110: 'Continuar',
    m111:
      'En {awto} tenemos dos modalidades de pago que se adecúan según tus preferencias, te contamos cuales son:',
    m112: 'Método Postpago',
    m113: '¿Cómo se gestionan los cobros hacia mi?',
    m114:
      'Los cobros se realizarán de forma automática a la tarjeta que decidas ingresar una vez tus viaje finalicen.',
    m115: '¿Cuáles son las alternativas de pago?',
    m116: `
      Puedes ingresar tu tarjeta a través de las siguientes alternativas: <br />
      <span class="bold">Kushki:</span> Acepta tarjetas de crédito emitidas por todos los países de Latinoamérica, excepto México y Brasil. <br />
      <span class="bold">One Click Mall:</span> Acepta solo tarjetas
      emitidas en Chile. <br />
      span class="bold">dLocal:</span> Acepta tarjetas de crédito emitidas por todo el mundo  <br /><br/>
      *Las tarjetas de crédito digitales no son válidas para esta modalidad de pago.
    `,
    m117: 'Método Prepago',
    m118: '¿Cómo funciona?',
    m119: `
      Debes tener un mínimo de $70.000 “Créditos Awto” cargados a tu cuenta.
      Para realizar los abonos debes ingresar al
      <span class="primary--text underline bold">“Área de socios”</span> de
      nuestra página web (<a-link
        class="underline bold"
        href="https://awto.cl"
        >www.awto.cl</a-link
      >) y hacer click en la sección “Créditos Awto”.
    `,
  },
  en: {
    ...messages.en,
    m79:
      'How to indicate the image, place your device at the height of your face.',
    m80: 'Avoid extra elements such as glasses or hats.',
    m81: 'Face verification',
    m82: 'Face identity verification',
    m83: 'Names',
    m84: 'Last name',
    m85: 'Review your data',
    m86: 'RUT / DNI / Passport',
    m87: 'Date of birth',
    m88: 'ID card',
    m89: 'Date of issue',
    m90: 'Expiration date',
    m91: 'Drivers license',
    m92: 'Step {step} of {total}',
    m93: 'Choose your membership',
    m94: 'Frequent',
    m95: 'monthly',
    m96: 'Normal price',
    m97: 'Access to all the fleet {awto} with exclusive prices',
    m98: 'Premium and hybrid category to enjoy the city',
    m99: 'Zero',
    m100: 'Access to the fleet with prices adjusted to what you use',
    m101: 'Join {awto} without commitments monthly and travel when you need',
    m102: 'Choose your payment method',
    m103: 'Select the payment method of your preference',
    m104: 'Payment method',
    m105: 'How is the payment process?',
    m106: 'Almost forgot...! I have a code!',
    m107:
      'Enter a promotional code or referral code to add minutes free to your travel',
    m108: 'Enter the code',
    m109: 'Validate',
    m110: 'Continue',
    m111:
      'In {awto} we have two payment methods that suit your preferences, we tell you which are:',
    m112: 'Postpaid method',
    m113: 'How are the payments made to me?',
    m114:
      'The payments to your card will be made automatically once the trips are finished.',
    m115: 'What are the alternatives of payment?',
    m116: `
      We have two alternatives:<br />
      <span class="bold">Kushki.</span> Accepts cards issued in Chile and
      the foreign.<br />
      <span class="bold">WebPay OneClick.</span> Accepts only cards
      issued in Chile.
    `,
    m117: 'Prepaid method',
    m118: 'How does it work?',
    m119: `
      You must have at least $70,000 “Awto Credits” loaded to your account.
      To make the payments you must enter to the
      <span class="primary--text underline bold">“Area of members”</span> of
      our website (<a-link
        class="underline bold"
        href="https://awto.cl"
        >www.awto.cl</a-link
      >) and click on the section “Awto Credits”.
    `,
  },
  pt: {
    ...messages.pt,
    m79:
      'Como indicar a imagem, coloque seu dispositivo na altura do seu rosto.',
    m80: 'Evite elementos extras como óculos ou chapéus.',
    m81: 'Verificação facial',
    m82: 'Verificação de identidade facial',
    m83: 'Nomes',
    m84: 'Sobrenome',
    m85: 'Revise seus dados',
    m86: 'CPF / Passaporte',
    m87: 'Data de nascimento',
    m88: 'Cédula de identidade',
    m89: 'Data de emissão',
    m90: 'Data de expiração',
    m91: 'Carteira nacional de habilitação',
    m92: 'Passo {step} de {total}',
    m93: 'Escolha sua associação',
    m94: 'Frequente',
    m95: 'mensal',
    m96: 'Preço normal',
    m97: 'Acesse toda a flota {awto} com preços exclusivos',
    m98: 'Categoria Premium e Híbrido para que disfrute da cidade',
    m99: 'Zero',
    m100: 'Acesse a flota com preços ajustados ao que você usa',
    m101: 'Junte-se a {awto} sem compromissos mensais e viaje quando precisar',
    m102: 'Escolha seu método de pagamento',
    m103: 'Selecione o método de pagamento de sua preferência',
    m104: 'Método de pagamento',
    m105: 'Como é o processo de pagamento?',
    m106: 'Quase esqueci...! Tenho um código!',
    m107:
      'Digite um código promocional ou referido para adicionar minutos gratis ao seu viagem',
    m108: 'Digite o código',
    m109: 'Validar',
    m110: 'Continuar',
    m111:
      'Em {awto} temos dois métodos de pagamento que se adequam às suas preferências, vamos contar quais são:',
    m112: 'Pagamentos',
    m113: 'Quais métodos de pagamento são aceitos pela Awto?',
    m114:
      'Por enquanto aceitamos apenas os pagamentos via cartão de crédito, estamos trabalhando para que no futuro você também possa adicionar fundos pré-pagos em sua conta Awto.',
    m115: 'Como funciona o processo de pagamento das viagens?',
    m116: `
      No Awto o pagamento é realizado diretamente pelo cartão de crédito previamente cadastrado em nossa plataforma.<br /><br />
      <p class="bold">Como é feita a cobrança da minha viagem?</p> 
      A cobrança é realizada automaticamente assim que a viagem é finalizada pelo usuário no App.
    `,
    m117: '',
    m118: '',
    m119: '',
  },
  br: {
    ...messages.pt,
    m79:
      'Como indicar a imagem, coloque seu dispositivo na altura do seu rosto.',
    m80: 'Evite elementos extras como óculos ou chapéus.',
    m81: 'Verificação facial',
    m82: 'Verificação de identidade facial',
    m83: 'Nomes',
    m84: 'Sobrenome',
    m85: 'Revise seus dados',
    m86: 'RUT / DNI / Passaporte',
    m87: 'Data de nascimento',
    m88: 'Cédula de identidade',
    m89: 'Data de emissão',
    m90: 'Data de expiração',
    m91: 'Licença de condutor',
    m92: 'Passo {step} de {total}',
    m93: 'Escolha sua associação',
    m94: 'Frequente',
    m95: 'mensal',
    m96: 'Preço normal',
    m97: 'Acesse toda a flota {awto} com preços exclusivos',
    m98: 'Categoria Premium e Híbrido para que disfrute da cidade',
    m99: 'Zero',
    m100: 'Acesse a flota com preços ajustados ao que você usa',
    m101: 'Junte-se a {awto} sem compromissos mensais e viaje quando precisar',
    m102: 'Escolha seu método de pagamento',
    m103: 'Selecione o método de pagamento de sua preferência',
    m104: 'Método de pagamento',
    m105: 'Como é o processo de pagamento?',
    m106: 'Quase esqueci...! Tenho um código!',
    m107:
      'Digite um código promocional ou referido para adicionar minutos gratis ao seu viagem',
    m108: 'Digite o código',
    m109: 'Validar',
    m110: 'Continuar',
    m111:
      'Em {awto} temos dois métodos de pagamento que se adequam às suas preferências, vamos contar quais são:',
    m112: 'Pagamentos',
    m113: 'Quais métodos de pagamento são aceitos pela Awto?',
    m114:
      'Por enquanto aceitamos apenas os pagamentos via cartão de crédito, estamos trabalhando para que no futuro você também possa adicionar fundos pré-pagos em sua conta Awto.',
    m115: 'Como funciona o processo de pagamento das viagens?',
    m116: `
      No Awto o pagamento é realizado diretamente pelo cartão de crédito previamente cadastrado em nossa plataforma.<br /><br />
      <p class="bold">Como é feita a cobrança da minha viagem?</p> 
      A cobrança é realizada automaticamente assim que a viagem é finalizada pelo usuário no App.
    `,
    m117: '',
    m118: '',
    m119: '',
  },
};

messages = {
  es: {
    ...messages.es,
    m120: '¿Cuáles son las alternativas de pago?',
    m121: `
      Tenemos cuatro alternativas de carga:<br />
      <span class="bold">Webpay Plus.</span> Tarjetas de crédito y débito
      nacionales<br />
      <span class="bold">dLocal:</span> Disponibiliza múltiples método de pago nacionales <br />
    `,
    m122: 'Desde ${min} cada minuto manejado',
    m123: 'Desde ${min} cada minuto estacionado',
    m124: 'Selecciona el método de pago de tu preferencia',
    m125: 'Medio de pago',
    m126: `
      <p><b>¿Cuáles son las alternativas de pago?</b></p>
      Tenemos cuatro alternativas de carga:<br />
      <span class="bold">Webpay Plus.</span> Tarjetas de crédito y débito
      nacionales<br />
      <span class="bold">App Móvil OnePay</span><br />
      <span class="bold"
        >Tarjetas de Prepago (MACH BCI, SuperDigital y Prepago Los
        Héroes)</span
      >
    `,
    m127: 'Procesar mi pago',
    m128: 'Elige tu método de pago',
    m129: `
      ¡Bienvenido!
      <br class="d-none d-md-block" />
      Ya eres parte de la comunidad {awto}
    `,
    m130: 'Te hemos enviado un mail',
    m131: 'Estamos verificando tu cuenta y en breve te notificaremos.',
    m132: 'Una vez completada la verificación, podrás utilizar tu cuenta Awto',
    m133: 'Información de tu suscripción',
    m134: 'Medio de pago',
    m135: '¡Abre puertas y maneja!',
    m136: 'Descarga la App y reserva tu vehículo más cercano',
    m137: 'Finalizar mi registro',
    m138: 'Ha ocurrido un problema',
    m139: 'No hemos podido validar tu proceso de verificación',
    m140: 'La cédula no pudo ser validada',
    m141: 'Imagen del rostro no pasa las validaciones mínimas',
    m142: `
      Esto puede deberse a que las fotos de tu carnet y/o selfie están
      borrosas, o bien, tus documentos no corresponden biométricamente con
      la selfie<br />
      Por este motivo te devolvemos unos pasos para que completes el proceso
      manualmente.<br />
      Disculpa las molestias.
    `,
    m143: `
      Lo sentimos, hubo un error interno en TOC y no pudimos validar tu
      identidad <br />
      Por este motivo te devolvemos unos pasos para que completes el proceso
      manualmente.<br />
      Disculpa las molestias.
    `,
    m144: '¿Necesitas ayuda?',
    m145: 'Sigue estas instrucciones',
    m146: 'Intentar de nuevo de forma automática',
    m147: 'Intentar de forma manual',
    m148: 'Entendido',
    m149:
      'Este proceso nos ayuda a tener certeza de saber que tu documentación está vigente para usar {awto}',
    m150: 'Tomar foto Reversa',
    m151: '¿Cómo debo tomar las fotografías de mis documentos?',
    m152: 'Sigue estas instrucciones',
  },
  en: {
    ...messages.en,
    m120: 'What are the payment options?',
    m121: `
      We have four payment options:<br />
      <span class="bold">Webpay Plus.</span> Credit and debit cards in
      national<br />
      <span class="bold">App Móvil OnePay</span><br />
      <span class="bold"
        >Prepaid cards (MACH BCI, SuperDigital and Prepago Los Heroes)</span
      >
    `,
    m122: 'From ${min} per minute handled',
    m123: 'From ${min} per minute parked',
    m124: 'Select your preferred payment method',
    m125: 'Payment method',
    m126: `
      <p><b>What are the alternatives of payment?</b></p>
      We have four payment options:<br />
      <span class="bold">Webpay Plus.</span> Credit and debit cards in
      national<br />
      <span class="bold">App Móvil OnePay</span><br />
      <span class="bold"
        >Prepaid cards (MACH BCI, SuperDigital and Prepago Los Heroes)</span
      >
    `,
    m127: 'Process my payment',
    m128: 'Choose your payment method',
    m129: `
      Welcome!
      <br class="d-none d-md-block" />
      You are part of the {awto} community
    `,
    m130: 'We have sent you an email',
    m131: 'We are verifying your account and will notify you shortly.',
    m132:
      'Once the verification is completed, you will be able to use your Awto account',
    m133: 'Subscription information',
    m134: 'Payment method',
    m135: 'Open doors and drive!',
    m136: 'Download the App and reserve your nearest vehicle',
    m137: 'Finish my registration',
    m138: 'An error has occurred',
    m139: 'We could not validate your verification process',
    m140: 'The document could not be validated',
    m141: 'The face image did not pass the minimum validations',
    m142: `
      This could be due to that your face image and/or selfie are blurry, or
      your documents do not match the selfie<br />
      For this reason we return you steps to complete the process manually.<br />
      Sorry for the inconvenience.
    `,
    m143: `
      We are sorry, there was an internal error in TOC and we could not validate
      your identity <br />
      For this reason we return you steps to complete the process manually.<br />
      Sorry for the inconvenience.
    `,
    m144: 'Do you need help?',
    m145: 'Follow these instructions',
    m146: 'Try again automatically',
    m147: 'Try manually',
    m148: 'Got it',
    m149:
      'This process helps us to know that your documents are valid to use {awto}',
    m150: 'Take selfie Reversa',
    m151: 'How do I take the face images of my documents?',
    m152: 'Follow these instructions',
  },
  pt: {
    ...messages.pt,
    m120: '',
    m121: '',
    m122: 'A partir de ${min} por minuto dirigido',
    m123: 'A partir de ${min} por minuto estacionado',
    m124: 'Selecione o método de pagamento de sua preferência',
    m125: 'Método de pagamento',
    m126: '',
    m127: 'Processar meu pagamento',
    m128: 'Escolha seu método de pagamento',
    m129: `
      Bem-vindo!
      <br class="d-none d-md-block" />
      Você já é parte da comunidade AWTO
    `,
    m130: 'Enviamos um email',
    m131: 'Estamos verificando sua conta e em breve notificaremos.',
    m132: 'Uma vez verificada sua conta, você poderá utilizar sua conta Awto',
    m133: '',
    m134: 'Método de pagamento',
    m135: 'Abre as portas e maneja!',
    m136: 'Baixe a App e reserve seu veículo mais próximo',
    m137: 'Finalize meu registro',
    m138: 'Ocorreu um problema',
    m139: 'Não conseguimos validar seu processo de verificação',
    m140: 'O documento não pôde ser validado',
    m141: 'A imagem do rosto não passou nas validações mínimas',
    m142: `
      Isso pode dever-se a que as fotos de seu cartão e/ou selfie estão
      borrosas, ou bien, os documentos não correspondem biométricamente com
      a selfie<br />
      Por este motivo retornamos-lhe passos para que complete o processo
      manualmente.<br />
      Disculpe as molestias.
    `,
    m143: `
      Desculpe, ocorreu um erro interno no TOC e não conseguimos validar sua
      identidade <br />
      Por este motivo retornamos-lhe passos para que complete o processo
      manualmente.<br />
      Disculpe as molestias.
    `,
    m144: 'Precisa de ajuda?',
    m145: 'Siga estes passos',
    m146: 'Tentar novamente automaticamente',
    m147: 'Tentar manualmente',
    m148: 'Entendi',
    m149:
      'Este processo ajuda-nos a saber que seus documentos são válidos para usar {awto}',
    m150: 'Faça selfie Reversa',
    m151: 'Como faço para tirar as fotos do meu documento?',
    m152: 'Siga estes passos',
  },
  br: {
    ...messages.pt,
    m120: '',
    m121: '',
    m122: 'De ${min} por minuto manejado',
    m123: 'De ${min} por minuto estacionado',
    m124: 'Selecione o método de pagamento de sua preferência',
    m125: 'Método de pagamento',
    m126: '',
    m127: 'Processar meu pagamento',
    m128: 'Escolha seu método de pagamento',
    m129: `
      Bem-vindo!
      <br class="d-none d-md-block" />
      Você já é parte da comunidade AWTO
    `,
    m130: 'Enviamos um email',
    m131: 'Estamos verificando sua conta e em breve notificaremos.',
    m132: 'Uma vez verificada sua conta, você poderá utilizar sua conta Awto',
    m133: '',
    m134: 'Método de pagamento',
    m135: 'Abre as portas e maneja!',
    m136: 'Baixe a App e reserve seu veículo mais próximo',
    m137: 'Finalize meu registro',
    m138: 'Ocorreu um problema',
    m139: 'Não conseguimos validar seu processo de verificação',
    m140: 'O documento não pôde ser validado',
    m141: 'A imagem do rosto não passou nas validações mínimas',
    m142: `
      Isso pode dever-se a que as fotos de seu cartão e/ou selfie estão
      borrosas, ou bien, os documentos não correspondem biométricamente com
      a selfie<br />
      Por este motivo retornamos-lhe passos para que complete o processo
      manualmente.<br />
      Disculpe as molestias.
    `,
    m143: `
      Desculpe, ocorreu um erro interno no TOC e não conseguimos validar sua
      identidade <br />
      Por este motivo retornamos-lhe passos para que complete o processo
      manualmente.<br />
      Disculpe as molestias.
    `,
    m144: 'Precisa de ajuda?',
    m145: 'Siga estes passos',
    m146: 'Tentar novamente automaticamente',
    m147: 'Tentar manualmente',
    m148: 'Entendi',
    m149:
      'Este processo ajuda-nos a saber que seus documentos são válidos para usar {awto}',
    m150: 'Faça selfie Reversa',
    m151: 'Como faço para tirar as fotos do meu documento?',
    m152: 'Siga estes passos',
  },
};

messages = {
  es: {
    ...messages.es,
    m153: 'Agrega tu cédula de identidad',
    m154: 'Tomar foto Frontal',
    m155: 'Paga con Kushki',
    m156: 'Verificando pago',
    m157: `
      No hemos logrado verificar tu método de pago.
      <span>Por favor inténtalo de nuevo</span>
    `,
    m158: 'Ha ocurrido un problema con tu medio de pago',
    m159: 'Intentar de nuevo',
    m160: 'Crea tu PIN para reservar',
    m161: 'Ingresa un PIN de 4 dígitos',
    m162: 'Siguiente',
    m163: 'No tienes permisos para acceder a este recurso',
    youMustEnterFourDigitsOfCode: 'Debe ingresar los 4 digitos del código',
    thisFieldMustHave: 'Este campo debe tener',
    characters: 'caracteres',
    basicInformationOfYourAccount: 'Información básica de tu cuenta',
    passwordsMustMatch: 'Las contraseñas deben coincidir',
    youMustCompleteTheReCAPTCHAToContinue:
      'Debes completar el reCAPTCHA para continuar',
    thePhoneNumberIsInvalidPleaseCheckAgain:
      'El número de teléfono es inválido, por favor verifícalo de nuevo',
    iHaveReadAndAcceptedThe: 'He leído y acepto los',
    termsOfUse: 'Condiciones de uso',
    contact: 'Contacto',
    m164: 'Todos los derechos reservados',
    m165:
      'Tu registro está en estado de revisión. Este proceso puede tardar hasta 48 horas hábiles',
    m166: 'Prefiero no decir',
    m167: 'Agrega tu cédula de identidad',
    m168: 'Confirma tu número telefónico',
    m169: 'Revisa tus datos',
    m170: 'Verificación de documentación e identidad',
    m171: 'Agrega tu licencia de conducir',
    m172: 'Paga con Kushki',
    m173: 'Escoge tu membresía',
    m174: 'Elige tu método de pago',
    m175: 'Procesar mi pago',
    m176: 'Ha ocurrido un problema con tu medio de pago',
    m177: 'Confirma tu número telefónico',
    m178: 'Crea tu PIN para reservar',
    m179: 'Ingresa un PIN de 4 dígitos',
    m180: 'Agrega tu cédula de identidad',
    m181: 'Verificando pago',
    m182: 'Selecciona un tipo de documento',
    m183: 'Tipo de documento',
    m184: '15.835.925-3',
  },
  en: {
    ...messages.en,
    m153: 'Add your identity document',
    m154: 'Take a selfie Frontal',
    m155: 'Pay with Kushki',
    m156: 'Verifying payment',
    m157: `
      We could not verify your payment method.
      <span>Please try again</span>
    `,
    m158: 'There was a problem with your payment method',
    m159: 'Try again',
    m160: 'Create your PIN to reserve',
    m161: 'Enter a 4 digit PIN',
    m162: 'Next',
    m163: 'You do not have permission to access this resource',
    youMustEnterFourDigitsOfCode: 'You must enter the 4 digits of the code',
    thisFieldMustHave: 'This field must have',
    characters: 'characters',
    basicInformationOfYourAccount: 'Basic information of your account',
    passwordsMustMatch: 'Passwords must match',
    youMustCompleteTheReCAPTCHAToContinue:
      'You must complete the reCAPTCHA to continue',
    thePhoneNumberIsInvalidPleaseCheckAgain:
      'The phone number is invalid, please check again',

    iHaveReadAndAcceptedThe: 'I have read and accepted the',
    termsOfUse: 'Terms of use',
    contact: 'Contact',
    m164: 'All rights reserved',
    m165:
      'Your record is in review status. This process can take up to 48 business hours.',
    m166: 'I prefer not to say',
    m167: 'Add your identity card',
    m168: 'Confirm your phone number',
    m169: 'Check your data',
    m170: 'Documentation and identity verification',
    m171: "Add your driver's license",
    m172: 'Pay with Kushki',
    m173: 'Choose your membership',
    m174: 'Choose your payment method',
    m175: 'Process my payment',
    m176: 'There has been a problem with your payment method',
    m177: 'Confirm your phone number',
    m178: 'Create your PIN to book',
    m179: 'Enter a 4-digit PIN',
    m180: 'Add your identity card',
    m181: 'Verifying payment',
    m182: 'Select a type of document',
    m183: 'Document type',
    m184: '15.835.925-3',
  },
  pt: {
    ...messages.pt,
    m153: 'Adicione seu documento de identidade',
    m154: 'Faça uma selfie Frontal',
    m155: 'Pague com Kushki',
    m156: 'Verificando pagamento',
    m157: `
      Não conseguimos verificar seu método de pagamento.
      <span>Por favor tente novamente</span>
    `,
    m158: 'Ocorreu um problema com seu método de pagamento',
    m159: 'Tente novamente',
    m160: 'Crie seu PIN para reservar',
    m161: 'Digite um PIN de 4 dígitos',
    m162: 'Próximo',
    m163: 'Você não tem permissão para acessar este recurso',
    youMustEnterFourDigitsOfCode: 'Você deve digitar os 4 dígitos do código',
    thisFieldMustHave: 'Este campo deve ter',
    characters: 'caracteres',
    basicInformationOfYourAccount: 'Informações básicas da sua conta',
    passwordsMustMatch: 'As senhas devem coincidir',
    youMustCompleteTheReCAPTCHAToContinue:
      'Você deve completar o reCAPTCHA para continuar',
    thePhoneNumberIsInvalidPleaseCheckAgain:
      'O número de telefone é inválido, por favor verifique novamente',
    iHaveReadAndAcceptedThe: 'Eu li e aceito os',
    termsOfUse: 'Termos de uso',
    contact: 'Contato',
    m164: 'Todos os direitos reservados',
    m165:
      'Tu registro está en estado de revisión. Este proceso puede tardar hasta 48 horas hábiles',
    m166: 'Prefiro não dizer',
    m167: 'Adicione sua carteira de identidade',
    m168: 'Confirme seu número de telefone',
    m169: 'Verifique seus dados',
    m170: 'Documentação e verificação de identidade',
    m171: 'Adicione sua carteira de motorista',
    m172: 'Pague com Kushki',
    m173: 'Escolha sua associação',
    m174: 'Escolha o seu método de pagamento',
    m175: 'Processar meu pagamento',
    m176: 'Ocorreu um problema com sua forma de pagamento',
    m177: 'Confirme seu número de telefone',
    m178: 'Crie seu PIN para reservar',
    m179: 'Digite um PIN de 4 dígitos',
    m180: 'Adicione sua carteira de identidade',
    m181: 'Verificando o pagamento',
    m182: 'Selecione um tipo de documento',
    m183: 'Tipo de documento',
    m184: '123.456.789-09',
  },
  br: {
    ...messages.pt,
    m153: 'Adicione seu documento de identidade',
    m154: 'Faça uma selfie Frontal',
    m155: 'Pague com Kushki',
    m156: 'Verificando pagamento',
    m157: `
      Não conseguimos verificar seu método de pagamento.
      <span>Por favor tente novamente</span>
    `,
    m158: 'Ocorreu um problema com seu método de pagamento',
    m159: 'Tente novamente',
    m160: 'Crie seu PIN para reservar',
    m161: 'Digite um PIN de 4 dígitos',
    m162: 'Próximo',
    m163: 'Você não tem permissão para acessar este recurso',
    youMustEnterFourDigitsOfCode: 'Você deve digitar os 4 dígitos do código',
    thisFieldMustHave: 'Este campo deve ter',
    characters: 'caracteres',
    basicInformationOfYourAccount: 'Informações básicas da sua conta',
    passwordsMustMatch: 'As senhas devem coincidir',
    youMustCompleteTheReCAPTCHAToContinue:
      'Você deve completar o reCAPTCHA para continuar',
    thePhoneNumberIsInvalidPleaseCheckAgain:
      'O número de telefone é inválido, por favor verifique novamente',
    iHaveReadAndAcceptedThe: 'Eu li e aceito os',
    termsOfUse: 'Termos de uso',
    contact: 'Contato',
    m164: 'Todos os direitos reservados',
  },
};

messages = {
  ...messages,
  br: messages.pt,
  'pt-BR': messages.pt,
  'pt-PT': messages.pt,
};

const getNavigatorLanguage = () =>
  navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.userLanguage ||
      navigator.language ||
      navigator.browserLanguage ||
      'en';

export default new VueI18n({
  locale: getNavigatorLanguage(),
  messages,
  silentTranslationWarn: true,
  fallbackLocale: 'es',
});
